import { render, staticRenderFns } from "./PlayHuay.vue?vue&type=template&id=0ff3df7f&scoped=true&"
import script from "./PlayHuay.vue?vue&type=script&lang=js&"
export * from "./PlayHuay.vue?vue&type=script&lang=js&"
import style0 from "./PlayHuay.vue?vue&type=style&index=0&id=0ff3df7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff3df7f",
  null
  
)

export default component.exports